var path = '@collectivehealth/get-care/app/mapResults/providerReviews/yelpRating/yelpRating.html';
var html = "<div class=\"YelpRating YelpRating--{{YelpRating.rating}}\"></div>\n";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;